import { useState } from "react";
import { faqs } from "@/mocks/topics";
import SectionTitle from "@/components/feature/SectionTitle";

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="w-full bg-background-100 py-14 md:py-16">
      <div className="container-x max-w-4xl">
        <SectionTitle
          kicker="常见问题"
          title="追更前，你想知道的都在这"
          desc="关于更新频率、收藏、付费与设备支持的常见疑问，一站为你解答。"
        />
        <div className="divide-y divide-background-300/60 rounded-lg border border-background-300/60 bg-background-50">
          {faqs.map((item, idx) => (
            <div key={idx}>
              <button
                onClick={() => setOpen(open === idx ? null : idx)}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                aria-expanded={open === idx}
              >
                <h3 className="flex items-center gap-3 font-heading text-base font-bold text-foreground-950">
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-100 text-xs font-bold text-primary-600">
                    {idx + 1}
                  </span>
                  {item.q}
                </h3>
                <i
                  className={`shrink-0 text-xl text-foreground-500 transition-transform ${open === idx ? "rotate-180 text-primary-600" : ""}`}
                >
                  {open === idx ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"}
                </i>
              </button>
              {open === idx && (
                <p className="px-5 pb-5 pl-14 text-sm leading-relaxed text-foreground-600">{item.a}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}